import { useEffect } from "react";
import { canonicalUrl, canonicalBase } from "@/lib/canonical";

const DEFAULT_OG = "/assets/og/azeka-global.png";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Per-page SEO. `title` is the full, already-composed page title. `siteName` sets
// og:site_name ("Azeka Global" or "Azeka Health"). Canonical/OG URLs are pinned to
// the correct canonical domain via lib/canonical.
export function Seo({ title, description, path = "", image, jsonLd, siteName = "Azeka Global", canonical: canonicalOverride, robots }) {
  useEffect(() => {
    const fullTitle = title || siteName;
    document.title = fullTitle;
    const canonical = canonicalOverride || canonicalUrl(path);
    const rawImg = image || DEFAULT_OG;
    const absImg = rawImg.startsWith("http") ? rawImg : canonicalBase() + rawImg;

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", siteName);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", absImg);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", absImg);
    if (robots) upsertMeta("name", "robots", robots);
    upsertLink("canonical", canonical);

    let script = document.getElementById("ld-json");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "ld-json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, jsonLd, siteName, canonicalOverride, robots]);

  return null;
}
